import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PalletTransactions_ds_pallet_classes_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { full_text_search?: string, project_id?: number }): 
  Promise<{ result: { Id?: number, Name?: string, Inventory?: { Amount?: number, Id?: number, Count?: number, PalletClassId?: number, PalletClass?: { Name?: string } }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/PalletTransactions/datasources/ds_pallet_classes_dd/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { full_text_search?: string, project_id?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Name?: string, Inventory?: { Amount?: number, Id?: number, Count?: number, PalletClassId?: number, PalletClass?: { Name?: string } }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/PalletTransactions/datasources/ds_pallet_classes_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { full_text_search?: string, project_id?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, Name?: string, Inventory?: { Amount?: number, Id?: number, Count?: number, PalletClassId?: number, PalletClass?: { Name?: string } }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PalletTransactions/datasources/ds_pallet_classes_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      full_text_search?: string, project_id?: number    }) {
      return false;
    }
}
